<!-- /src/components/common/Notifications.vue -->
<template>
  <div class="notifications">
    <transition-group name="foo" tag="ul" class="notifications__items">
      <li
        v-for="(n, i) in notifications"
        :key="`notification_${i}`"
        class="notifications__items__item"
        :class="[
          `notifications__items__item--${n.type}`,
          {
            'notifications__items__item--closable': n.closable,
            'notifications__items__item--autoClose': n.autoClose,
          },
        ]"
        :data-notification="n.id"
      >
        <span v-html="n.msg"></span>
        <span
          class="notifications__items__item__icon"
          @click="$store.dispatch('notification/remove', n.id)"
          v-show="n.closable"
        >
          <i class="fal fa-times icon"></i>
        </span>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },

  mounted() {
    // const testNotifications = [
    //   {
    //     type: 'error',
    //     msg: 'This is an error message that closes automatically.',
    //     closable: false,
    //     autoClose: true,
    //   },
    //   {
    //     type: 'notice',
    //     msg: 'This is a notice.',
    //     closable: false,
    //     autoClose: true,
    //   },
    //   {
    //     type: 'error',
    //     msg: "This is another error with a longer message. It's also closable.",
    //     closable: true,
    //     autoClose: false,
    //   },
    //   {
    //     type: 'error',
    //     msg: 'This is an error message.',
    //     closable: true,
    //     autoClose: false,
    //   },
    //   {
    //     type: 'notice',
    //     msg: 'This is a notice.',
    //     closable: false,
    //     autoClose: true,
    //   },
    //   {
    //     type: 'error',
    //     msg: "This is another error with a longer message. It's also closable.",
    //     closable: true,
    //     autoClose: false,
    //   },
    // ]
    // testNotifications.forEach(n => this.$store.dispatch('notification/add', n))
  },

  computed: {
    notifications() {
      return this.$store.getters['notification/all']
    },
  },

  methods: {
    clearNotification(n) {
      return this.$store.dispatch('notification/remove', n)
    },
  },

  watch: {
    notifications(newVal) {
      newVal
        .filter(n => n.autoClose === true)
        .reverse()
        .forEach((n, i) => {
          let self = this
          setTimeout(() => {
            return self.$store.dispatch('notification/remove', n.id)
          }, 5000 * (i + 1))
        })
    },
  },
}
</script>

<style scoped>
.notifications {
  position: fixed;
  left: 50%;
  top: 1rem;
  z-index: 9999999;
  width: 400px;
  color: white;
  font-size: 0.7rem;
  transform: translateX(-50%);

  &__items {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;

    &__item {
      position: relative;
      display: inline-block;
      background-color: rgba(0, 0, 0, 0.7);
      margin-bottom: 0.5rem;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.5);
      transition: transform 0.5s ease, box-shadow 0.5s ease;
      will-change: transform box-shadow;

      &--notice {
        background-color: rgb(66, 165, 33);
      }

      &--error {
        background-color: rgb(154, 0, 0);

        &:hover {
          /* background-color: rgba(154, 0, 0, 1); */
        }
      }

      &--closable {
        padding-right: 2rem;
      }

      &__icon {
        position: absolute;
        right: 8px;
        top: 8px;
        width: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 12px;
        background-color: rgba(0, 0, 0, 0.5);
        cursor: pointer;
      }
    }
  }
}

.foo-item {
  margin: 0;
}

.foo-enter-active,
.foo-leave-active {
  /* buggy */
  /* transition: all 2s ease; */

  transition: opacity 0.5s ease, transform 0.5s ease;
}

.foo-move {
  transition: transform 0.2s ease;
}

.foo-enter,
.foo-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
